import { RealtyObjectType } from '@search/filter-enums/enums/RealtyObjectType';
import { SeoSearchCommonProps } from './seoSearchCommon';
import { seoSearchFlatRoom } from './seoSearchFlatRoom';
import { seoSearchLand } from './seoSearchLand';
import { seoSearchHome } from './seoSearchHome';

export function seoSearch(opts: SeoSearchCommonProps) {
    if (opts.params.categoryType === RealtyObjectType.HOUSE) return seoSearchHome(opts);
    if (opts.params.categoryType === RealtyObjectType.LAND) return seoSearchLand(opts);

    return seoSearchFlatRoom(opts);
}
